export const taxPageRows = 30;
export const taxRowsPerPageOptions = [30, 50, 100, 200];